import { AnalyticsContext } from '@shared/contexts/AnalyticsContext';
import { VoomaApiClient } from '@shared/generated/graphql';
import { useContext } from 'react';

type PlatformState = {
  apiClient: VoomaApiClient;
  isWeb: boolean;
  isPlugin: boolean;
  isOutlook: boolean;
  isGmail: boolean;
  isFront: boolean;
};

export function usePlatform(): PlatformState {
  const { apiClient } = useContext(AnalyticsContext);

  return {
    apiClient,
    isWeb: apiClient === VoomaApiClient.WEB,
    isPlugin: [
      VoomaApiClient.OUTLOOK,
      VoomaApiClient.CHROME,
      VoomaApiClient.FRONT,
    ].includes(apiClient),
    isOutlook: apiClient === VoomaApiClient.OUTLOOK,
    isGmail: apiClient === VoomaApiClient.CHROME,
    isFront: apiClient === VoomaApiClient.FRONT,
  };
}
